<div class="role-selector-wrapper">
    <button mat-button [matMenuTriggerFor]="menu" [style.width]="width | px2rem" (click)="pannelVisible = !pannelVisible"
        (menuClosed)="pannelVisible=false" data-cy="role-selector-button">
        <div class="role-selectot-button">
            <div>
                <i class="role-selector-icon rb rb-icon-{{selectedRole.icon}}"></i>
                <div>{{selectedRole && selectedRole.name ? selectedRole.name:'Role'}}</div>
            </div>
            <i matSuffix class="rb rb-icon-arrow-{{pannelVisible?'up':'down'}}" style="font-size: 20px;"></i>
        </div>
    </button>
    <mat-menu #menu="matMenu" [style.width]="width | px2rem">
        <button mat-menu-item *ngFor="let role of userRoles" [attr.data-cy]="'role-selector-item-' + role.name" [style.width]="width | px2rem" (click)="onRoleSelected(role)"
            style="display: flex;align-items: center;"
            [disabled]="!userService.isAdmin && role.id === externalRoleId"
            [ngStyle]="selectedRole && selectedRole.id == role.id ? {'color': '#E70F96;','background-color':'#FFFAFD'} : {'color': '#6B6167;'}">
            <i class="rb rb-icon-{{role.icon}}" style="margin-right: 10px;font-size: 20px;
            font-family: 'Open Sans';"></i>{{role.name}}
        </button>
    </mat-menu>
</div>